<template>
  <MainLayout>
    <Head title="Vehicles" />

    <template v-slot:header>Vehicles</template>

    <div class="mb-4" v-if="$can('vehicles.write')">
      <ButtonGroup>
        <Link :href="$route('vehicles.create')">Add Vehicle</Link>
        <button type="button" @click="sync"><RefreshIcon class="w-4 h-4 mr-2" /> Sync options</button>
      </ButtonGroup>
    </div>

    <IndexSearch :filters="filters" class="mb-4" />

    <DataTable :pagination="vehicles">
      <template v-slot:header>
        <th scope="col" class="">
          Name
        </th>
        <th scope="col">
          Make
        </th>
        <th scope="col">
          Model
        </th>
        <th scope="col">
          Submodel
        </th>
        <th scope="col">
          Years
        </th>
        <th scope="col">
          <span class="sr-only">Edit</span>
        </th>
      </template>

      <tr v-for="vehicle in vehicles.data" :key="vehicle.id">
        <td>{{ vehicle.name }}</td>
        <td>{{ vehicle.make }}</td>
        <td>{{ vehicle.model }}</td>
        <td>{{ vehicle.submodel }}</td>
        <td>{{ getYears(vehicle) }}</td>
        <td>
          <div class="flex gap-2 place-content-end">
            <button type="button"
                    class="text-red-600 hover:text-red-900"
                    v-if="$can('builds.write')"
                    @click="deleteVehicle(vehicle)">Delete</button>
            <Link :href="$route('vehicles.edit', [vehicle.id])" class="text-indigo-600 hover:text-indigo-900">Edit</Link>
          </div>
        </td>
      </tr>
    </DataTable>
  </MainLayout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import PageComponent from '@/pages/page-component';
import DataTable from '@/components/data-table.vue'
import IndexSearch from './index-search.vue'
import UsesPermissions from '@/mixins/uses-permissions'
import {
  RefreshIcon,
} from '@heroicons/vue/solid'

export default {
  mixins: [
    PageComponent,
    UsesPermissions,
  ],

  components: {
    DataTable,
    Link,
    IndexSearch,
    RefreshIcon,
  },

  props: {
    vehicles: Object,
    filters: Object,
  },

  methods: {
    getYears (vehicle) {
      return [vehicle.start_year, vehicle.end_year]
        .reduce(
          (carry, item) => carry.includes(item)
            ? carry
            : carry.concat(item),
          [],
        )
        .join('-')
    },

    deleteVehicle (vehicle) {
      if (confirm('Are you sure?')) {
        Inertia.delete(this.$route('vehicles.destroy', [vehicle.id]))
      }
    },

    sync() {
      const warning = "Warning: this action will overwrite existing options mapping. Do you want to continue?"

      if (confirm(warning)) {
        Inertia.post(this.$route('vehicles.sync-options'))
      }
    },
  }
}
</script>
